import script from "./Document.vue?vue&type=script&lang=ts&setup=true"
export * from "./Document.vue?vue&type=script&lang=ts&setup=true"

import "./Document.vue?vue&type=style&index=0&id=26f805d6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26f805d6"]])

export default __exports__